import request from '@/utils/request'

/* get subpage data */
export function getSubPage(params) {
  return request({
    url: '/api/Index/NewsList',
    method: 'get',
    params
  })
}

export function getCommunitySubPage(params) {
  return request({
    url: '/api/Index/QueryByInfo',
    method: 'get',
    params
  })
}

/* get honor subpage data */
export function getHonorList(params) {
  return request({
    url: '/api/Index/HonorList',
    method: 'get',
    params
  })
}
/* get subpage data detail */
export function getSubPageDetail(params) {
  return request({
    url: '/api/Index/NewsInfo',
    method: 'get',
    params
  })
}

/* get id 7 subpage data */
export function getSubPageId7(params) {
  return request({
    url: '/api/Index/SecondarySeven',
    method: 'get',
    params
  })
}
/* get id 12 subpage data */
export function getSubPageId12(params) {
  return request({
    url: '/api/Index/SecondaryTwelve',
    method: 'get',
    params
  })
}
/* get id 11 subpage data */
export function getSubPageId11(params) {
  return request({
    url: '/api/Index/SecondaryEleven',
    method: 'get',
    params
  })
}

export function getCommunityIntro(params) {
  return request({
    url: '/api/Index/communityIntro',
    method: 'get',
    params
  })
}

/* page template */
// 党务公开
export function getPublicityParty(params) {
  return request({
    url: '/api/Index/publicityParty',
    method: 'get',
    params
  })
}
// 居务公开
export function getPublicityHousing(params) {
  return request({
    url: '/api/Index/publicityHousing',
    method: 'get',
    params
  })
}
// 森林防灭火
export function getFireFighting(params) {
  return request({
    url: '/api/Index/fireFighting',
    method: 'get',
    params
  })
}
// 退役军人服务
export function getVeteransService(params) {
  return request({
    url: '/api/Index/veteransService',
    method: 'get',
    params
  })
}
// 基层党风廉政
export function getPartyConduct(params) {
  return request({
    url: '/api/Index/partyConduct',
    method: 'get',
    params
  })
}
// 妇联工作
export function getFemaleFederation(params) {
  return request({
    url: '/api/Index/femaleFederation',
    method: 'get',
    params
  })
}
// newPage8
export function getNewPage8(params) {
  return request({
    url: '/api/Index/newpage8',
    method: 'get',
    params
  })
}
export function getNewPage9(params) {
  return request({
    url: '/api/Index/newpage9',
    method: 'get',
    params
  })
}
export function getNewPage10(params) {
  return request({
    url: '/api/Index/newpage10',
    method: 'get',
    params
  })
}
export function getNewPage11(params) {
  return request({
    url: '/api/Index/newpage11',
    method: 'get',
    params
  })
}
export function getNewPage12(params) {
  return request({
    url: '/api/Index/newpage12',
    method: 'get',
    params
  })
}
